import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { EnrolledUserItem } from "../types";

interface UseEnrolledUsersListArgs {
  corporateId: string | number;
  objectId: number;
  page: number;
  pageSize: number;
  search?: string;
  status?: string;
  enrollType?: string;
}

export const useEnrolledUsersList = ({
  corporateId,
  objectId,
  page,
  pageSize,
  search,
  status,
  enrollType,
}: UseEnrolledUsersListArgs): PaginatedListResult<EnrolledUserItem> => {
  const url = corporateId
    ? `${ServicesURL.getEnrollment}?corporateId=${corporateId}&objectId=${objectId}`
    : null;

  return usePaginatedList<EnrolledUserItem>(
    url,
    {
      page,
      pageSize,
      search,
      fieldFilters: {
        ...(status ? { status } : {}),
        ...(enrollType ? { enrollType } : {}),
      },
    },
    {
      responseKey: "enrollmentResponses",
      totalElementsKey: "totalElements",
      totalPagesKey: "totalPages",
    },
  );
};
